import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['item', 'grid', 'gutter']

  connect() {
    this.msnry = new Masonry( this.gridTarget, {
      itemSelector: '.gallery__item',
      columnWidth: '.gallery__grid .gallery__item-sizer',
      gutter: '.gallery__grid .gallery__item-gutter'
    });
  }

  load() {
    let index = this.getImageSize()
    let items = this.itemTargets
    let msnry = this.msnry
    items.forEach(item => {
      let img = item.querySelector('.gallery__item--image')
      let sizes = JSON.parse(img.dataset.lazy)
      img.src = sizes[index]
    })

    imagesLoaded(items, function() {
      msnry.layout()
      items.forEach(item => {
        item.style.opacity = 1
      })
    })
  }

  getImageSize() {
    let gutter_sizes = [20, 30, 40]
    let width = window.getComputedStyle(this.gutterTarget).getPropertyValue('width')
    let gutter = parseInt(width, 10)
    return gutter_sizes.indexOf(gutter)
  }

  openImageOverlay(e) {
    e.preventDefault()
    let item = e.target.parentNode
    document.documentElement.classList.add('-is-open-overlay')
    document.querySelector('#overlay').setAttribute('tabindex', -1)
    this.appendGalleryContent(item)
    this.overlayEvents()
  }

  appendGalleryContent(data) {
    let overlay = document.querySelector('#overlay .overlay__content')
    let existing = overlay.querySelector('.gallery__item')
    let element = data.cloneNode(true)
    if (existing) existing.remove()
    element.removeAttribute('style')
    overlay.appendChild(element)
    let sizes = JSON.parse(overlay.querySelector('.gallery__item--image').dataset.lazy)
    let index = this.getImageSize()
    overlay.querySelector('.gallery__item--image-wrapper').style.backgroundImage = `url(${sizes[index]})`

    let pagerLeft = overlay.querySelector('.gallery__item--pager-left')
    let pagerRight = overlay.querySelector('.gallery__item--pager-right')

    if (data.dataset.prev == '') {
      pagerLeft.style.display = 'none'
    } else {
      pagerLeft.style.display = 'inline-flex'
    }
    if (data.dataset.next == '') {
      pagerRight.style.display = 'none'
    } else {
      pagerRight.style.display = 'inline-flex'
    }
  }

  overlayEvents() {
    let overlay = document.querySelector('#overlay')
    let close = overlay.querySelector('.overlay__close')
    overlay.querySelectorAll('.gallery__item--pager').forEach(pager => {
      pager.addEventListener('click', this.pager.bind(this))
    })
    close.addEventListener('click', this.closeOverlay)
  }

  closeOverlay(e) {
    e.preventDefault()
    document.documentElement.classList.remove('-is-open-overlay')
  }

  pager(e) {
    e.preventDefault()
    let overlay = document.querySelector('#overlay')
    let parent = overlay.querySelector('.gallery__item')
    let prev = parent.dataset.prev
    let next = parent.dataset.next
    let dir = e.target.dataset.dir
    let element = this.gridTarget.querySelector("." + eval(dir))
    // let element = $('.gallery__grid').find("." + eval(dir))
    this.appendGalleryContent(element)
  }

}
